import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { injectIntl, FormattedMessage } from 'react-intl'

import * as tutorialActions from '../tutorial.actions'

const TutorialBattlesMessageScreen = ({ removeScreen }) => (
  <div className="tutorial--response" style={{ zIndex: '1000' }}>
    <h1 className="h1">
      <FormattedMessage id="tutorial.turn3.academy_text.title" />
    </h1>
    <p>
      <FormattedMessage id="tutorial.turn3.academy_text.p1" />
    </p>
    <p>
      <FormattedMessage id="tutorial.turn3.academy_text.p2" />
    </p>
    <p>
      <b>
        <FormattedMessage id="tutorial.turn3.academy_text.p2_end" />
      </b>
    </p>
    <p>
      <FormattedMessage id="tutorial.turn3.academy_text.p3" />
    </p>
    <p>
      <b>
        <FormattedMessage id="tutorial.turn3.academy_text.p3_end" />
      </b>
    </p>
    <div className="btn--orange" onClick={() => removeScreen('battles_message_screen')}>
      <span className="icon-rocket"></span>
      <span>
        <FormattedMessage id="tutorial.common_texts.start" />
      </span>
    </div>
  </div>
)

const mapDispatchToProps = (dispatch) => ({
  removeScreen: bindActionCreators(tutorialActions.removeScreen, dispatch),
})

TutorialBattlesMessageScreen.propTypes = {
  removeScreen: PropTypes.func,
}

export default connect(null, mapDispatchToProps)(injectIntl(TutorialBattlesMessageScreen))
